import * as React from 'react';
import styles from './unconsented.module.scss';
import { ChildWidgetProps } from '..';
import { CompanyStore } from '../../../../stores/companyStore';
import { event } from '../../../../utils/tracking';
import { GoogleAnalyticsCategory } from '../../../../models/dtos/enums';
import FooterWidget from '../../../_common/footerWidget';

export interface UnconsentedWidgetProps extends ChildWidgetProps {
  companyStore: CompanyStore;
  onClick(): void;
}

class UnconsentedWidget extends React.Component<UnconsentedWidgetProps> {
  constructor(props: UnconsentedWidgetProps) {
    super(props);

    this.props.widgetStore.setMenuVisibility(false);
  }

  componentDidMount() {
    // Company settings are already fetched and stored in CompanyStore
    this.props.onFinished();
  }

  handleOnClick = () => {
    event({
      category: GoogleAnalyticsCategory.UnconsentedWidget,
      action: 'Click Get Cash',
    });
    this.props.onClick();
  };

  render() {
    const { companyStore } = this.props;
    
    return (
      <div className={styles.widget}>
        <div className={`${styles.content} ${styles.grayScrollbar}`}>
          <p className={styles.title}>Welcome to ReadyCash!</p>
          <p
            className={styles.subHead}
            dangerouslySetInnerHTML={{
              __html: companyStore.marketingSpiel,
            }}
          ></p>
          <p
            className={styles.note}
            dangerouslySetInnerHTML={{
              __html: companyStore.marketingSpielNote,
            }}
          ></p>
        </div>
        <FooterWidget>
          <button className={`${styles.button} primaryBtn`} onClick={this.props.onClick}>
            <span>Continue</span>
          </button>
        </FooterWidget>
      </div>
    );
  }
}

export default UnconsentedWidget;
